<template>
    <b-row>
        <div class="d-flex mt-3 mb-3">
            <img src="../../../../assets/Img/icons/downsymbol.svg" alt="" class="down-symbol">
            <h6 class="bold-heading mt6 ms-1">{{ $t('bankInfo.title') }}</h6>
        </div>
    </b-row>
    <!-- {{ dataObj }} -->

    <b-row class="my-2 ps-3">
        <div class="details-card">
            <b-col lg="12" class="">
                <p class="display-field-label d-flex flex-row-reverse">PREFERRED</p>
            </b-col>
            <b-col lg="12" class="form-field-column">
                <p class="mb-3 details-black-field">{{ dataObj.BankName }} - {{ dataObj.BankBranch }}</p>
            </b-col>
            <b-col lg="12" class="form-field-column">
                <p class="display-field-label">{{ dataObj.IFSC }}</p>
            </b-col>
        </div>
    </b-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
    props: {
        dataObj: {
            type: Object,
            default: {}
        }
    },
    setup() {
        return {

        }
    }

})
</script>

<style lang="scss"></style>